export interface EncryptedPax {
  firstName: string;
  lastName: string;
  firstNameNum: string;
  LastNameNum: string;
  passengerResourceId: string;
  tickets: EncryptedTicket[];
}

export interface EncryptedSegments {
  segmentId: string;
  marketingCarrier: string;
  flightNum: string;
}

export interface EncryptedTrip {
  tripId: string;
  segments: EncryptedSegments[];
}

export interface EncryptResponse {
  recordLocator: string;
  bidUpgradeToken?: string;
  chaufferToken?: string;
  passengers: EncryptedPax[];
  trips: EncryptedTrip[];
}

export interface EncryptedTicket {
  number: string;
}
